module.exports = __webpack_public_path__ + "static/img/yytx25.e67e991.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx25.png
// module id = 804
// module chunks = 0